import { render } from "./CustomActionBtn.vue?vue&type=template&id=3aeb4fb6&scoped=true"
import script from "./CustomActionBtn.vue?vue&type=script&lang=js"
export * from "./CustomActionBtn.vue?vue&type=script&lang=js"

import "./CustomActionBtn.vue?vue&type=style&index=0&id=3aeb4fb6&lang=scss&scoped=true"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aeb4fb6"]])

export default __exports__